import { memo } from 'react'
import { Link, useSearchParams } from 'react-router-dom'

import { InfoCard } from '../../../../components/InfoCard'
import { Heading } from '../Heading'

export interface TwinCreationContentProps {
  openNextTab: () => void
}

const TwinCreationContent: React.FC<TwinCreationContentProps> = memo(
  ({ openNextTab }) => {
    const [searchParams] = useSearchParams()
    const isMacos = searchParams.get('platform') === 'macos'

    return (
      <>
        <Heading title="Your Digital Twin Works When You Can't" />
        <div className="max-w-[544px] m-auto">
          <video
            autoPlay
            loop
            muted
            playsInline
            disablePictureInPicture
            className="w-full object-cover rounded-2xl aspect-video "
            src="https://mentordata-acazgce6cvdzgng9.z02.azurefd.net/marketing/twin-video-reduced.mp4"
          />
          <InfoCard
            className="mt-4"
            title="Why create a twin?"
            description="Be in two places at once. Your twin can talk to colleagues, fans or clients while you focus - or even while you sleep. Every conversation lands in your Inbox."
          />
          <InfoCard
            title="Office hours: always available"
            description="Your likeness and voice remain yours. Manage or delete your AI twin anytime."
          />
          <div className="flex gap-4 justify-center mt-4">
            <Link
              data-testid="do-this-later-link"
              className="btn btn-secondary sm:!grow-0 !grow"
              to={isMacos ? 'napster-companion://cloning-close' : '/'}
            >
              Do This Later
            </Link>
            <button
              data-testid="create-my-twin-btn"
              className="btn btn-primary sm:!grow-0 !grow"
              onClick={openNextTab}
            >
              Create My Twin
              <i className="fa-solid fa-arrow-right ml-2" />
            </button>
          </div>
          <p className="mt-2 text-center text-dark-neutral-200 text-xs">
            Around 5 minutes to complete. Your twin belongs to you. Edit or
            delete anytime.
          </p>
        </div>
      </>
    )
  },
)

export { TwinCreationContent }

